import { RouteInfo } from './sidebar.metadata';
export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard/main',
    title: 'Tableau de bord',
    iconType: 'material-icons-outlined',
    icon: 'dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'TABLEAU_DE_BORD',
    submenu: [],
  },
  {
    path: '',
    title: 'Réception',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    submenu: [],
  },
  {
    path: '/planning',
    title: 'Planning',
    iconType: 'material-icons-outlined',
    icon: 'calendar_view_month',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'PLANNING',
    submenu: [],
  },
  {
    path: '/administration/verification-reglement',
    title: 'Règlements à vérifier',
    iconType: 'material-icons-outlined',
    icon: 'verified',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'VERIFICATION_REGLEMENT',
    submenu: [],
  },
  {
    path: '',
    title: 'Service caisse',
    iconType: 'material-icons-outlined',
    icon: 'point_of_sale',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'SERVICE_CAISSE',
    submenu: [
      {
        path: '/service-caisse/pass',
        title: 'Pass',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'SERVICE_PASS',
        submenu: [],
      },
      {
        path: '/service-caisse/nuitee',
        title: 'Nuitée',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'SERVICE_NUITE',
        submenu: [],
      },
      {
        path: '/service-caisse/journee',
        title: 'Journée',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'SERVICE_JOURNEE',
        submenu: [],
      },
      {
        path: '/service-caisse/sejour',
        title: 'Séjour',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'SERVICE_SEJOUR',
        submenu: [],
      },
      {
        path: '/service-caisse/gestion-espace',
        title: 'Gestion espace',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'GESTION_ESPACE',
        submenu: [],
      },
      {
        path: '/service-caisse/accueil-boutique',
        title: 'Accueil boutique',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'CAISSE_BOUTIQUE',
        submenu: [],
      },
      {
        path: '/service-caisse/accueil-restau',
        title: 'Accueil restaurant',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'CAISSE_RESTAURANT',
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'Accueil',
    iconType: 'material-icons-outlined',
    icon: 'support_agent',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'ACCUEIL',
    submenu: [
      {
        path: '/accueil/reservation',
        title: 'Réservations',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'RESERVATION',
        submenu: [],
      },
      {
        path: '/accueil/hebergement',
        title: 'Hébergements',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'HEBERGEMENT',
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'Ventes',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    submenu: [],
  },
  {
    path: '',
    title: 'Restaurant',
    iconType: 'material-icons-outlined',
    icon: 'restaurant',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'RESTAURANT',
    submenu: [
      {
        path: '/restaurant/menu-restau',
        title: 'Menu',
        iconType: 'material-icons-outlined',
        icon: 'menu_book',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'MENU_RESTAU',
        submenu: [],
      },
      {
        path: '/restaurant/commande-restau',
        title: 'Commandes',
        iconType: 'material-icons-outlined',
        icon: 'receipt_long',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'COMMANDE_RESTAU',
        submenu: [],
      },
      {
        path: '/restaurant/livraison-restau',
        title: 'Livraisons',
        iconType: 'material-icons-outlined',
        icon: 'delivery_dining',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'LIVRAISON_RESTAU',
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'Boutique',
    iconType: 'material-icons-outlined',
    icon: 'storefront',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'BOUTIQUE',
    submenu: [
      {
        path: '/boutique/commande-boutique',
        title: 'Commandes',
        iconType: 'material-icons-outlined',
        icon: 'shopping_cart',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'COMMANDE_BOUTIQUE',
        submenu: [],
      },
      {
        path: '/boutique/livraison-boutique',
        title: 'Livraisons',
        iconType: 'material-icons-outlined',
        icon: 'local_shipping',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'LIVRAISON_BOUTIQUE',
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: "Location d'espaces",
    iconType: 'material-icons-outlined',
    icon: 'meeting_room',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'LOCATION_ESPACE',
    submenu: [
      {
        path: '/location-espace/reservation-espace',
        title: "Réservations d'espace",
        iconType: 'material-icons-outlined',
        icon: 'event_available',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'RESERVATION_ESPACE',
        submenu: [],
      },
      {
        path: '/location-espace/occupation-espace',
        title: "Occupations d'espace",
        iconType: 'material-icons-outlined',
        icon: 'groups',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'OCCUPATION_ESPACE',
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'Gestion',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    submenu: [],
  },
  {
    path: '',
    title: 'Trésorerie',
    iconType: 'material-icons-outlined',
    icon: 'account_balance',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'TRESORERIE',
    submenu: [
      {
        path: '/tresorerie/demande-espece',
        title: "Demandes d'espèces",
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'DEMANDE_ESPECE',
        submenu: [],
      },
      {
        path: '/tresorerie/demande-reglement',
        title: 'Demandes de règlement et factures',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'DEMANDE_REGLEMENT',
        submenu: [],
      },
      // {
      //   path: '/tresorerie/reglement-fournisseur',
      //   title: 'Règlement fournisseur',
      //   iconType: '',
      //   icon: '',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   badge: '',
      //   badgeClass: '',
      //   codification: 'REGLEMENT_FOURNISSEUR',
      //   submenu: [],
      // },
      // {
      //   path: '/tresorerie/reglement-apporteur',
      //   title: 'Règlement apporteur',
      //   iconType: '',
      //   icon: '',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   badge: '',
      //   badgeClass: '',
      //   codification: 'REGLEMENT_APPORTEUR',
      //   submenu: [],
      // },
      // {
      //   path: '/tresorerie/reglement-espece',
      //   title: 'Règlement espèce',
      //   iconType: '',
      //   icon: '',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   badge: '',
      //   badgeClass: '',
      //   codification: 'REGLEMENT_ESPECE',
      //   submenu: [],
      // },
      {
        path: '/tresorerie/mouvement-caisse',
        title: 'Mouvements de caisse',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'MOUVEMENT_DE_CAISSE',
        submenu: [],
      },
      {
        path: '/tresorerie/recette',
        title: 'Recettes',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'RECETTE',
        submenu: [],
      },
      {
        path: '/tresorerie/depense',
        title: 'Règlements et dépenses',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'DEPENSE',
        submenu: [],
      },

      // {
      //   path: '/tresorerie/etat-compte',
      //   title: 'Etat compte',
      //   iconType: '',
      //   icon: '',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   badge: '',
      //   badgeClass: '',
      //   codification: 'ETAT_COMPTE',
      //   submenu: [],
      // },
      // {
      //   path: '/tresorerie/etat-caisse',
      //   title: 'Etat caisse',
      //   iconType: '',
      //   icon: '',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   badge: '',
      //   badgeClass: '',
      //   codification: 'ETAT_CAISSE',
      //   submenu: [],
      // },

      {
        path: '/tresorerie/transfert-fond',
        title: 'Transferts de fonds',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'TRANSFERT_FOND',
        submenu: [],
      },
      {
        path: '/tresorerie/situation-globale',
        title: 'Situation globale',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'SITUATION_GLOBALE',
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'Relation client',
    iconType: 'material-icons-outlined',
    icon: 'handshake',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'RELATION_CLIENT',
    submenu: [
      // {
      //   path: '/relation-client/remise-reservation',
      //   title: 'Remise reservation',
      //   iconType: '',
      //   icon: '',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   badge: '',
      //   badgeClass: '',
      //   codification: 'REMISE_RESERVATION',
      //   submenu: [],
      // },
      {
        path: '/relation-client/remise-hebergement',
        title: 'Remises hébergement',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'REMISE_HEBERGEMENT',
        submenu: [],
      },
      // {
      //   path: '/relation-client/remise-commande',
      //   title: 'Remise commande',
      //   iconType: '',
      //   icon: '',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   badge: '',
      //   badgeClass: '',
      //   codification: 'REMISE_COMMANDE',
      //   submenu: [],
      // },
      // {
      //   path: '/relation-client/remise-livraison',
      //   title: 'Remise livraison',
      //   iconType: '',
      //   icon: '',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   badge: '',
      //   badgeClass: '',
      //   codification: 'REMISE_LIVRAISON',
      //   submenu: [],
      // },
      {
        path: '/relation-client/demande-ristourne',
        title: 'Demandes de ristourne',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'DEMANDE_RISTOURNE',
        submenu: [],
      },
      {
        path: '/relation-client/fidelite-client',
        title: 'Fidélité client',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'FIDELITE_CLIENT',
        submenu: [],
      },
      {
        path: '/relation-client/contentieux',
        title: 'Contentieux',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'CONTENTIEUX',
        submenu: [],
      },
      {
        path: '/relation-client/reglement-client',
        title: 'Règlements clients',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'REGLEMENT_CLIENT',
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'Stock',
    iconType: 'material-icons-outlined',
    icon: 'inventory',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'GESTION_DE_STOCK',
    submenu: [
      {
        path: '/stock/commande',
        title: 'Commandes',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'COMMANDE',
        submenu: [],
      },
      {
        path: '/stock/livraison',
        title: 'Livraisons',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'LIVRAISON',
        submenu: [],
      },
      {
        path: '/stock/etat-stock',
        title: 'État du stock',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'ETAT_STOCK',
        submenu: [],
      },
      {
        path: '/stock/inventaire-stock',
        title: 'Inventaires',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'INVENTAIRE_STOCK',
        submenu: [],
      },
      {
        path: '/stock/sortie-divers',
        title: 'Sorties diverses',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'SORTIE_DIVERS',
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'Maintenance',
    iconType: 'material-icons-outlined',
    icon: 'build',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'MAINTENANCE',
    submenu: [
      {
        path: '/maintenance/programme',
        title: 'Programme',
        iconType: 'material-icons-outlined',
        icon: 'event_note',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'PROGRAMME_MAINTENANCE',
        submenu: [],
      },
      {
        path: '/maintenance/execution',
        title: 'Exécution',
        iconType: 'material-icons-outlined',
        icon: 'engineering',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'EXECUTION_MAINTENANCE',
        submenu: [],
      },
    ],
  },
  {
    path: '/ged',
    title: 'Documents',
    iconType: 'material-icons-outlined',
    icon: 'folder_open',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'GED',
    submenu: [],
  },
  {
    path: '',
    title: 'Pilotage',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    submenu: [],
  },
  {
    path: '/etat',
    title: 'État',
    iconType: 'material-icons-outlined',
    icon: 'bar_chart',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'ETAT',
    submenu: [],
  },
  {
    path: '',
    title: 'Audit',
    iconType: 'material-icons-outlined',
    icon: 'security',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'AUDIT',
    submenu: [
      {
        path: '/audit/historique-connexion',
        title: 'Historique des connexions',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'HISTORIQUE_CONNEXION',
        submenu: [],
      },
      {
        path: '/audit/historique-navigation',
        title: 'Historique de navigation',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'HISTORIQUE_NAVIGATION',
        submenu: [],
      },
      // {
      //   path: '/audit/logs',
      //   title: 'Logs',
      //   iconType: '',
      //   icon: '',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   badge: '',
      //   badgeClass: '',
      //   codification: 'LOGS',
      //   submenu: [],
      // },
    ],
  },
  {
    path: '',
    title: 'Système',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    submenu: [],
  },
  {
    path: '',
    title: 'Administration',
    iconType: 'material-icons-outlined',
    icon: 'admin_panel_settings',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'ADMINISTRATION',
    submenu: [
      {
        path: '',
        title: 'Accès',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: true,
        badge: '',
        badgeClass: '',
        submenu: [],
      },
      {
        path: '/administration/utilisateur',
        title: 'Utilisateurs hôtel',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'UTILISATEUR',
        submenu: [],
      },
      {
        path: '/administration/utilisateur-client',
        title: 'Utilisateurs clients',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'UTILISATEUR_CLIENT',
        submenu: [],
      },
      {
        path: '/administration/role',
        title: 'Rôles',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'ROLE',
        submenu: [],
      },
      {
        path: '/administration/licence',
        title: 'Licence',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'LICENCE',
        submenu: [],
      },
      {
        path: '',
        title: 'Fichiers',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: true,
        badge: '',
        badgeClass: '',
        submenu: [],
      },
      {
        path: '/administration/client',
        title: 'Clients',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'CLIENT',
        submenu: [],
      },
      {
        path: '/administration/apporteur',
        title: 'Apporteurs',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'APPORTEUR',
        submenu: [],
      },
      {
        path: '',
        title: 'Réglages',
        iconType: '',
        icon: '',
        class: '',
        groupTitle: true,
        badge: '',
        badgeClass: '',
        submenu: [],
      },
      {
        path: '/administration/config-reglement',
        title: 'Règlements',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'CONFIG_REGLEMENT',
        submenu: [],
      },
      {
        path: '/administration/notification',
        title: 'Notifications',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'NOTIFICATION',
        submenu: [],
      },
      {
        path: '/administration/besoin-equipement',
        title: 'Besoins en équipements',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'BESOIN_EQUIPEMENT',
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'Paramètres',
    iconType: 'material-icons-outlined',
    icon: 'settings',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: 'PARAMETRES',
    submenu: [
      {
        path: '/parametre/param-generaux',
        title: 'Paramètres généraux',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'PARAMETRES_GENERAUX',
        submenu: [],
      },
      {
        path: '/parametre/param-hotel',
        title: 'Paramètres hôtel',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'PARAMETRES_HOTEL',
        submenu: [],
      },
      {
        path: '/parametre/param-restaurant',
        title: 'Paramètres restaurant',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'PARAMETRES_RESTAURANT',
        submenu: [],
      },
      {
        path: '/parametre/param-espace',
        title: 'Paramètres espace',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'PARAMETRES_ESPACE',
        submenu: [],
      },
      {
        path: '/parametre/param-maintenance',
        title: 'Paramètres maintenance',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        codification: 'PARAMETRES_MAINTENANCE',
        submenu: [],
      },
    ],
  },
  {
    path: '/manuel-utilisation',
    title: "Manuel d'utilisation",
    iconType: 'material-icons-outlined',
    icon: 'menu_book',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    codification: '',
    submenu: [],
  },
];
